import { render, staticRenderFns } from "./car_Insurance.vue?vue&type=template&id=6e6fadbc&scoped=true"
import script from "./car_Insurance.vue?vue&type=script&lang=js"
export * from "./car_Insurance.vue?vue&type=script&lang=js"
import style0 from "./car_Insurance.vue?vue&type=style&index=0&id=6e6fadbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6fadbc",
  null
  
)

export default component.exports